import { Routes, Route } from "react-router-dom";
import Login from "./Login";
// import BugReport from "./BugReport";
import Quotes from "./Quotes";
import SendToInsurers from "./SendToInsurers";
import Redit from "./Redit";
import WelcomeBack from "./WelcomeBack";
import BrokerAdmin from "./BrokerAdmin";
import QuoteyAdmin from "./QuoteyAdmin";
import UserAdmin from "./UserAdmin";
import QuestionsFlow from "./QuestionsFlow";
import UserManagement from "../brokerageadmin/UserManagement";
import ClientHandOff from "./ClientHandOff";
import MyQuotes from "./MyQuotes";
import HomePage from "./HomePage";
import MyCustomers from "./MyCustomers";
import MyPolicies from "./MyPolicies";
import InsurerView from "./InsurerView";
import Testpdf from "./Testpdf";
import StipdfReady from "./StipdfReady";
import ThanksNoteForAnswers from "./ThanksNoteForAnswers";
import InsurerViewQF from "./InsurerViewQF";
import ProspectZoom from "./ProspectZoom";
import BinderZoom from "./BinderZoom";
import CustomerZoom from "./CustomerZoom";
import ViewCertificate from "./ViewCertificate";
import BindPolicies from "./BindPolicies";
import Reminders from "../reminders/Reminders";
import ViewCompare from "./ViewCompare";
import Test from "./Test";
import TermsConditions from "./TermsConditions";
import ForgotPassword from "./ForgotPassword";
import ViewCompareForPDF from "./ViewCompareForPDF";
import PasswordManagementContainer from "./PasswordManagementContainer";
import HelpfulVideos from "./HelpfulVideos";
import HelpfulVideosNew from "./HelpfulVideosNew";
import VerificationScreen from "./verification/VerificationScreen";
import EmailVerification from "./EmailVerification";
import Dashboard from "../brokeragesuperadmin/reports/Dashboard";
import CustomPaymentComponent from "./CustomPayment/CustomPaymentComponent";
import {Authenticate} from "../general/Authenticate";
import { getIsTwoFARequired, getTwofactorVerifiedKey } from "../store/broker";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TestLoginPage from "./TestLoginPage";

const PathSwitches = () => {
  const history = useNavigate();
  const isTwoFARequired = useSelector(getIsTwoFARequired);
  const getTwofactorkey = useSelector(getTwofactorVerifiedKey);

  return (
    <Routes>
      <Route path="/test-login" element={<TestLoginPage />} /> 
      <Route path="/authenticate" element={<Authenticate />} />
      
      <Route path="/signup" element={<PasswordManagementContainer />} />
      <Route exact path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<PasswordManagementContainer />} />
      <Route exact path="/terms" element={<TermsConditions />} />
      <Route exact path="/questions" element={<QuestionsFlow />} />
      <Route exact path="/chs" element={<ClientHandOff />} />
      <Route path="/login" element={<Login />} />
      {/* <Route path="/bugreport">
        <BugReport></BugReport>
      </Route> */}
      <Route exact path="/quotes" element={<Quotes />} />
      <Route exact path="/sti" element={<SendToInsurers />} />
      <Route exact path="/stipdfready" element={<StipdfReady />} />
      <Route exact path="/editresponse" element={<Redit />} />
      <Route exact path="/prospect" element={<ProspectZoom />} />
      <Route exact path="/customer" element={<CustomerZoom />} />
      <Route exact path="/reminders" element={<Reminders />} />
      <Route exact path="/binder" element={<BinderZoom />} />
      <Route exact path="/certificate" element={<ViewCertificate />} />
      <Route exact path="/myquotes" element={<MyQuotes />} />
      <Route exact path="/homepage" element={<HomePage />} />
      <Route exact path="/mycustomers" element={<MyCustomers />} />
      <Route exact path="/howtoVideos" element={<HelpfulVideosNew />} />
      <Route exact path="/testpdf" element={<Testpdf />} />
      <Route exact path="/test" element={<Test />} />

      <Route
        exact
        path="/customPdf/:prospectID/:insurerSelectedId/:tax/:brokerFees"
        element={<CustomPaymentComponent />}
      />

      <Route exact path="/verification/*" element={<EmailVerification />} />
      <Route exact path="/mypolicies" element={<MyPolicies />} />

      {getTwofactorkey ? (
        <Route
          exact
          path="/two-factor-verification"
          element={<VerificationScreen />}
        ></Route>
      ) : null}
      <Route exact path="/bindpolicies" element={<BindPolicies />} />
      <Route exact path="/iv" element={<InsurerView />} />
      <Route exact path="/cv" element={<ViewCompare />} />
      <Route exact path="/pdfcv" element={<ViewCompareForPDF />} />
      <Route exact path="/ivqf" element={<InsurerViewQF />} />
      <Route
        exact
        path="/thanksforanswers"
        element={<ThanksNoteForAnswers />}
      />
      <Route exact path="/brokeradmin/:view" element={<BrokerAdmin />} />
      <Route exact path="/quoteyadmin/:view" element={<QuoteyAdmin />} />
      <Route exact path="/useradmin/:view" element={<UserAdmin />} />
      {/* <Route exact path="/" element={<WelcomeBack />} /> */}
      
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="/broker-admin/user" element={<UserManagement />} />
      <Route exact path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
};

export default PathSwitches;
